var React = require('react');

function CircleGreyInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"7","cy":"7","r":"6","fill":"none","stroke":"#E1DCD8","strokeWidth":"2"}));
}

CircleGreyInline.defaultProps = {"width":"14","height":"14"};

module.exports = CircleGreyInline;

CircleGreyInline.default = CircleGreyInline;
